import React from 'react';
import { GroupWinner, ScoringRules, UserTeams } from '../../types';
import NameLink from '../NameLink/NameLink';

interface GroupWinnerCardWC26Props {
  groupWinner: GroupWinner;
  teamAllocs: UserTeams[];
  scoringRules: ScoringRules;
}

function GroupWinnerCardWC26({ groupWinner, teamAllocs, scoringRules }: GroupWinnerCardWC26Props) {
  const userTeam = teamAllocs.find(
    (t) => t.team1Id === groupWinner.teamId.toString()
      || t.team2Id === groupWinner.teamId.toString()
  );

  const points = userTeam?.team1Id === groupWinner.teamId.toString()
    ? scoringRules.t1WinGroup
    : scoringRules.t2WinGroup;

  return (
    <div className="group-winners-wc26-card">
      <div className="group-winners-wc26-label">{groupWinner.group}</div>
      <div className="group-winners-wc26-team">
        <img src={groupWinner.teamLogo} alt={groupWinner.teamName} />
        <p>{groupWinner.teamName}</p>
        {userTeam && (
          <div className="group-winners-wc26-team-names">
            <NameLink name={userTeam.name} />
          </div>
        )}
      </div>
      <div className="group-winners-wc26-points">{`${groupWinner.points}pts`}</div>
      <div className={`group-winners-wc26-score ${points > 0 ? 'positive' : 'neutral'}`}>
        {points > 0 ? `+${points}` : '-'}
      </div>
    </div>
  );
}

export default GroupWinnerCardWC26;
